import React from 'react'

const SignedUpStatusPill = ({type}) => {
    const reviewerType = {
        className: type === 'onSite' ? 'onSite' : 'reading',
        label: type === 'onSite' ? 'On Site' : 'Reading'
    }
    
    return (
        <div className={`status-pill ${reviewerType.className}`}>
            {reviewerType.label}{' Reviewer'}
        </div>
    )
}

export default SignedUpStatusPill



// WEBPACK FOOTER //
// ./src/components/reviews/SignedUpStatusPill.js